import { Button, CircularProgress, Divider, FormControlLabel, FormGroup, Icon, IconButton, Switch, TextField, Typography } from '@material-ui/core'
import { useValues } from 'hooks'
import { createAccountTypeService, editAccountTypeService, FIELDS } from 'lib'
import React from 'react'
import { useLocation } from 'react-router'
import { IAccountType } from 'types'

interface Props {
    onSuccess: () => void
    onError: () => void
    onClose: () => void
}

const AccountTypeForm = (props: Props) => {
    const location = useLocation()
    const { onError, onSuccess, onClose } = props
    const initialInput = React.useRef<any>(null)
    const [loading, setLoading] = React.useState<boolean>(false)
    const { values: accountType, updateValue: handleChange, updateValues } = useValues()
    const handleSumbit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault()
        try {
            setLoading(true)
            if (!(location.state as any)?.edit) {
                await createAccountTypeService({ ...accountType, active: true })
            } else {
                const edited = { ...accountType }
                delete edited[FIELDS.officeId.key]
                await editAccountTypeService(accountType[FIELDS.accountTypeId.key], { ...edited })
            }
            setLoading(false)
            if (!(location.state as any)?.edit) {
                updateValues({ description: "", accountCode: "", active: true } as IAccountType)
                initialInput.current?.focus()
            }
            onSuccess()
        } catch (error) {
            setLoading(false)
            onError()
        }
    }
    React.useEffect(() => {
        if ((location.state as any)?.edit) {
            if ((location.state as any)?.values) {
                updateValues((location.state as any)?.values)
            }
        }
    }, [location.state, updateValues])
    return (
        <div className="p-4">
            <div className="flex items-center justify-between">
                <Typography variant="body2" style={{ fontWeight: 600, letterSpacing: 0.5 }}>
                    {(location.state as any)?.edit ? "Editar tipo de cuenta" : "Nuevo tipo de cuenta"}
                </Typography>
                <IconButton onClick={onClose} size="small">
                    <Icon fontSize="small">close</Icon>
                </IconButton>
            </div>
            <form onSubmit={handleSumbit} className="pt-4 flex flex-col" style={{ width: 300 }}>
                <TextField
                    inputRef={initialInput}
                    autoFocus
                    size="small"
                    label={FIELDS.accountCode.name}
                    variant="outlined"
                    fullWidth
                    required
                    value={accountType[FIELDS.accountCode.key]}
                    onChange={(e) => handleChange(FIELDS.accountCode.key, e.target.value)}
                />
                <TextField
                    size="small"
                    label={FIELDS.description.name}
                    variant="outlined"
                    fullWidth
                    style={{ marginTop: 10 }}
                    multiline
                    onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault() } }}
                    rows={3}
                    required
                    value={accountType[FIELDS.description.key]}
                    onChange={(e) => handleChange(FIELDS.description.key, e.target.value)}
                />
                {
                    (location.state as any)?.edit &&
                    <FormGroup className="p-2" row>
                        <FormControlLabel
                            control={<Switch color="primary" size="small" checked={Boolean(accountType[FIELDS.active.key])} onChange={(e) => handleChange(FIELDS.active.key, e.target.checked)} name={FIELDS.active.name} />}
                            label={FIELDS.active.name}
                        />
                    </FormGroup>
                }
                <p>{accountType[FIELDS.active.key]}</p>
                <div className="mt-4">
                    <Divider />
                </div>
                <div className="flex justify-end pt-3">
                    <Button
                        size="small"
                        color="primary"
                        variant="contained"
                        disableElevation
                        disabled={loading}
                        type="submit"
                    >
                        {loading ? <CircularProgress style={{ color: "white" }} size={16} className="my-1" thickness={10} /> : (location.state as any)?.edit ? "Guardar" : "Registrar"}
                    </Button>
                </div>
            </form>
        </div>
    )
}

export default AccountTypeForm
